/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "common": {
            "nested": {
              "component": {
                "nested": {
                  "CardCustomization": {
                    "fields": {
                      "signatureImageBytes": {
                        "type": "bytes",
                        "id": 1,
                        "rule": "optional"
                      },
                      "mimeType": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "AsyncCardCustomization": {
                    "fields": {
                      "customizationToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.CardCustomization && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.AsyncCardCustomization) {
  $root.addJSON(jsonData);
}

/**
 * Customization shown on the front side of a Square (Debit) Card.
 *
 * SOURCE CardCustomization @ squareup/bbfrontend/common/component/card_customization.proto at 14:1
 */
export const CardCustomization = $root.lookupType('squareup.bbfrontend.common.component.CardCustomization');
fixType(CardCustomization, {
  mimeType: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CardCustomization);
/**
 * Lets the client fetch the card customization directly.
 *
 * SOURCE AsyncCardCustomization @ squareup/bbfrontend/common/component/card_customization.proto at 24:1
 */
export const AsyncCardCustomization = $root.lookupType('squareup.bbfrontend.common.component.AsyncCardCustomization');
fixType(AsyncCardCustomization, {
  customizationToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(AsyncCardCustomization);